import * as React from "react";
import { IBaseInputFieldProperty, IPropertyEditorProps, IUIFieldProps, registerUIField } from "../../common";
import { AutoCompleteInput, Checkbox, ICheckboxType, Input, Label, Select } from "uxp/components";
import { hasValue } from "../../../../util";
import { CustomColorPicker, escapeUnit, Property, PropertyContainer, PropertyGroup, PropertyGroupTitle, PropertyTitle } from "../../ui-props/common";
import { FieldProperty, FieldTitle, IFieldTitleProps } from "../../components/FieldTitle";


interface ICheckboxFieldProperty extends IBaseInputFieldProperty {
	label: string;
	labelColor?: string,
	labelFontSize?: string,
	type?: ICheckboxType,
	fieldLabel: IFieldTitleProps,

}

export const Field: React.FunctionComponent<IUIFieldProps<ICheckboxFieldProperty>> = (props) => {
	let { value, onChange, label, labelColor, labelFontSize, type } = props?.fieldProps || {};

	let labelStyles: React.CSSProperties = {}
	if (hasValue(labelColor)) labelStyles.color = labelColor
	if (hasValue(labelFontSize)) labelStyles.fontSize = labelFontSize

	return (
		<div className={`ui-field ${props.mode}`} >
			<FieldTitle {...props?.fieldProps?.fieldLabel || {}} />
			<Checkbox
				type={type || 'default'}
				checked={toBool(value)}
				onChange={onChange}
				label={label}
				labelStyles={labelStyles}
			/>
		</div>
	)
}


function toBool(x: any) {
	if (typeof x == 'boolean') {
		return x;
	}
	if (typeof x == 'string') {
		x = x.trim().toLowerCase();
		if (x == '0' || x == 'false' || x == '') {
			return false;
		} else {
			return true;
		}
	}
	return !!x;
}
export const PropertyEditor: React.FunctionComponent<IPropertyEditorProps<ICheckboxFieldProperty>> = (props) => {
	return <PropertyContainer>
		<PropertyGroup>
			<PropertyGroupTitle>Checkbox</PropertyGroupTitle>
			<Property>
				<PropertyTitle>Type</PropertyTitle>
				<Select
					selected={props.uiProps.type || 'default'}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { type: s }))}
					options={[
						{ label: 'Box', value: 'default' },
						{ label: 'Box width border', value: 'bordered' },
						{ label: 'Switch (box)', value: 'switch-box' },
						{ label: 'Switch (line)', value: 'switch-line' },
					]}
				/>
			</Property>
			<Property>
				<PropertyTitle>Checkbox Text</PropertyTitle>
				<AutoCompleteInput
					placeholder="I agree"
					value={props.uiProps.label || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { label: s }))}
					options={[]}
				/>
			</Property>

			<Property>
				<PropertyTitle>Value</PropertyTitle>
				<AutoCompleteInput
					placeholder="True or false"
					value={props.uiProps.value || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { value: s }))}
					options={['true', 'false']}
				/>
			</Property>

			{/* <Property>
				<PropertyTitle>Lable Color</PropertyTitle>
				<CustomColorPicker contextData={props.contextData}
					color={props.uiProps.labelColor || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { labelColor: s }))}
				/>
			</Property>

			<Property>
				<PropertyTitle>Font Size (px) </PropertyTitle>
				<Input
					type='number'
					value={escapeUnit(props.uiProps.labelFontSize || '12', 'px')}
					onChange={s => {
						let num = Number(s) || 0
						if (num < 8) s = '8'
						else if (num > 200) s = '200'
						props.onChange(Object.assign({}, props.uiProps, { labelFontSize: s + 'px' }))
					}}
					inputAttr={{
						max: '200',
						min: '8'
					}}
					className="widget-designer-input"
				/>
			</Property> */}

		</PropertyGroup>
		<FieldProperty uiProps={props.uiProps} onChange={props.onChange} />
	</PropertyContainer>
}

registerUIField({
	id: 'checkbox',
	description: 'Checkbox',
	field: Field,
	propertyEditor: PropertyEditor,
	isInputField: true,
	defaultProps: {
		label: 'I agree',
		fieldLabel: {

		}
	},
	type: 'true/false'

});
